import { render, staticRenderFns } from "./NoteGroup.vue?vue&type=template&id=9fe41db4&scoped=true"
import script from "./NoteGroup.vue?vue&type=script&lang=js"
export * from "./NoteGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe41db4",
  null
  
)

export default component.exports